import { useTranslation } from "react-i18next";
import { SideButtons } from "./sideButtons";
import { useEffect, useRef, useState } from "react";

import plans from '../icons/plans.png';
import unit from '../icons/unit.png';
import visit from '../icons/360.png';
import contact from '../icons/contact.png';
import CustomAccordion from "./accordion";

export const Menu = ({ current, setCurrent, changeVirtualScene, tmpFloorUnit, setFloorUnit, setCurrLvl }) => {
    const { i18n, t } = useTranslation();
    const contactLink = i18n.language === "fr" ? "https://liria.ca/projets/saint-jerome/#form" : "https://liria.ca/en/projects/saint-jerome/#form";

    const clickMenu = (main, sub) => {
        setCurrent({ main, sub });
        changeVirtualScene(sub);
    }

    return (
        <div className="flex flex-col h-full overflow-y-auto justify-between items-end">
            <div className="w-full">
                <img className="p-[20px] lg:p-10 w-auto h-[80px] lg:pb-0 pb-0 sm:h-auto sm:w-full mx-auto" src="./images/logo.png" />

                {/* <div className="flex-1 h-[1px] bg-[var(--gold)] mb-[20px] my-[20px] mx-[20px] lg:mx-10"></div> */}
                <div className="flex-1 h-[1px] mb-[20px] my-[20px]"></div>

                <SideButtons reclick icon={plans} onClick={() => { clickMenu("plans", "floor"); setCurrLvl(0); }} id="plans" current={current} isFirst text={t("plansSelector")} />

                {current?.sub === "floor" ?
                    <SideButtons icon={unit} id="floor" current={current} second text={t("chooseFloor")} /> :
                    current?.sub === "unit" ?
                        <SideButtons icon={unit} id="unit" current={current} second text={t("chooseUnit")} /> :
                        <></>
                }
                <SideButtons icon={visit} onClick={() => { clickMenu("visit", "billard2"); setFloorUnit(current.sub); }} id="visit" current={current} text={t("virtualVisit")} />
                {/* Sous menu visite virtuelle */}

                {(current?.sub !== "floor" && current?.sub !== "unit") &&
                    <>
                        <CustomAccordion defaultOpen={true} title={t("commonSpace")}>
                            {/* <h4 className="text-[13px] lg:text-[16px] text-[var(--goldLite)] font-[Caslon] py-2 px-[60px] border-b border-b-[var(--gold)]">{t("commonSpace")}</h4> */}
                            <SideButtons second onClick={() => clickMenu("visit", "billard2")} id="billard2" current={current} text={t("vBillard")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "gym")} id="gym" current={current} text={t("vGym")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "hall")} id="hall" current={current} text={t("vHall")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "lounge")} id="lounge" current={current} text={t("vLounge")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "terrace")} id="terrace" current={current} text={t("vTerrace")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "garden")} id="garden" current={current} text={t("vGarden")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "pool")} id="pool" current={current} text={t("vPool")} small />
                        </CustomAccordion>
                        {/* Unité type */}
                        {/* <h4 className="text-[13px] lg:text-[16px] text-[var(--goldLite)] font-[Caslon] py-2 px-[60px]">{t("uniteType")}</h4> */}
                        <SideButtons title forceActiveCode="u_" second onClick={() => clickMenu("visit", "u_sam")} id="u_sam" current={current} text={t("uniteType")} small />
                        <div className="w-full h-[1px] bg-[var(--gold)]"></div>
                    </>
                }

                <SideButtons icon={contact} onClick={() => window.open(contactLink, '_blank')} id="contact" current={current} text={t("contact")} />
            </div>
            {/* Logo Edge */}
            <img
                onClick={() => window.open('https://www.edgedimension.com/' + i18n.language, '_blank')}
                className={`z-[10] my-[10px] mr-[10px] p-2 rounded transition-all w-[75px] hover:opacity-100 opacity-50 cursor-pointer`}
                src={`./images/logo-edge_${i18n.language}.png`}
            />
        </div>
    )
}